module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/003acknowledgements"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/004dedication"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "foreword"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005foreword"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "theartofbarbecue"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006theartofbarbecue"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("The Art of Barbecue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "toolsandtechniques"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007toolsandtechniques"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Tools and Techniques")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "thecookers"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008thecookers"
    }
  }, [_vm._v("The Cookers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "char"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/009charcoalandwood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charcoal and Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "barbecuetools"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/010barbecuetools",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecue Tools")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 1 Spices and Sauces")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecue Rub #67")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecue Rub #68")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ray’s Supersweet Rib Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicago Ray’s Prime Rib Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. BBQ’s Fired-Up Fajita Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superchicken Wing Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herby Rub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real North Carolina Vinegar Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thick and Rich Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thin and Spicy Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yellow Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Chipotle Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr Pepper Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter1#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Ketchup")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 2 Ribs Rule the World")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memphis-Style Wet Baby Back Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memphis-Style Dry Baby Back Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asian-Sauced Baby Back Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spareribs with Yellow Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roadside Barbecue Spareribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Louis–Cut Ribs with Orange-Chipotle Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecue Championship Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country-Style Barbecued Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Windy City Rib Tips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Korean-Style Barbecue Short Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter2#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoky Braised Beef Short Ribs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 3 Pork, Glorious Pork")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Low and Slow Memphis-Style Pulled Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competition-Style Pork Butt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Smoked Pork Picnic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cuban-Style Leg of Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon-Wrapped Pig Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sliced Pork Shoulder Roast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Maple-Brined Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Pork Loin with Banana Ketchup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Pork Steaks with Whiskey Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cilantro-Smeared Pork Tenderloin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter3#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Smoked Ham with Apricot Glaze")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 4 Beautiful Beef")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pulled Barbecue Beef")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real Texas-Style Beef Brisket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competition-Style Beef Brisket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Flat-Cut Brisket with Coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Pastrami")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoky Roast Beef au Mushroom Jus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Holiday Prime Rib")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoky Skirt Steak Fajitas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Bacon and Blue Cheese–Stuffed Hamburgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter4#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meat Loaf with Dr Pepper Barbecue Sauce")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 5 The Birds")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old-School Barbecued Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken on a Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superchicken Smoked Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competition-Style Barbecued Chicken Thighs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon and Herb–Smoked Chicken Legs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("State Fair Turkey Legs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louisiana-Style Thanksgiving Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buffalo Turkey Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cozy Corner–Style Cornish Hens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter5#sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecued Duck with Spicy Orange Glaze")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 6 Anything But")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Stuffed Baby Bellas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jambalaya-Stuffed Bell Peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Scotch Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big-Time Kielbasa Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecued Bologna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herby Rubbed Leg of Lamb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Smoked Tilapia Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Salmon with Honey-Orange Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planked Salmon with Soy-Honey Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter6#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Shrimp Cocktail")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Chapter 7 The Necessary Side Dishes")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carolina-Style Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon and Blue Cheese Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sandi’s Sweet ‘n’ Spicy Baked Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judy’s Little Red Potato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Smoked Cheesy Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Jalapeño Grits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Mac and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. BBQ’s Bacon Maque Choux")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marsha’s Chocolate Buttermilk Mac Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "sec_76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter7#sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World’s Greatest Banana Pudding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "index"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "table"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019tableofequivalents",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Table of Equivalents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/020abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/021copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Copyright")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7befe84a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/022toc.vue
// module id = 69
// module chunks = 0